// extracted by mini-css-extract-plugin
module.exports = {"aboutMe":"AboutMe_aboutMe__3CXWy","projectsLink":"AboutMe_projectsLink__3wYvX"};